import React from 'react'
import "./Services.css"
import ServicesCard from './ServicesCard'

const Services = () => {
  return (
    <div className="services_parent">

      {/* TEXT */}
      <section className="text">
        <h3>Offered</h3>
        <h1>Services</h1>
        <p>Responsive Websites & Web Apps, and Full Stack Web Apps Development</p>
        <ul>
          <li>Custom Web Development ( HTML, CSS, JS ReactJs, Firebase)</li>
          <li>Blockchain Web Apps (Minting, Wallet Connectivity, Smart Contract Integration)</li>
          <li>Graphic Designing (Logo Design, Cv Design, Photo Editing)</li>
          <li>Content and Copy Writing (Web Pages, Blog & Article Writing)</li>
        </ul>
      </section>


      {/* Cards */}
      <section className="card_parent">
        <ServicesCard icon="fa-solid fa-desktop" title="Custom Web App" text="We focus on creating a modern, flexible, secure, cross-platform, and user-friendly web app so that it can meet spikes in demand and handle complex scenarios"/>

        <ServicesCard icon="fa-solid fa-boxes-stacked" title="Contract Integration / Minting" text="We do smart Contract integration in which includes functionalities minting, whitelist, get data from Blockchain and update on it, buy tokens and etc"/>

        <ServicesCard icon="fa-solid fa-wallet" title="Wallet Connectivity" text="We do wallet integration in Blockchain. These wallets include Metamask, Coinbase, Trust, Sollana, etc. We also connect these wallets with the front end"/>

        <ServicesCard icon="fa-brands fa-hive" title="Landing Pages" text="We pay special attention to create attention-grabbing landing pages that convince your users to take the required action. We use a combination of eye-catching backgrounds and images to make each section stand out"/>

        <ServicesCard icon="fa-brands fa-hive" title="NFT Landing Pages" text="We design unique NFT landing pages with awesome animations and themes. These landing pages have 5 to 7 sections that include, engaging content, Art slider, Roadmap, Team, Faq, etc."/>

        <ServicesCard icon="fa-solid fa-laptop-code" title="Responsive websites" text="We create responsive websites via CSS and JavaScript plugins. Our design has a flexible layout and images that work on various devices: mobile, desktop, tablet, etc. We create websites that efficiently deal with different media queries, screen sizes, resolutions, color capabilities, and resolutions."/>

        <ServicesCard icon="fa-brands fa-hive" title="Full Stack Web Apps" text="We develop full-stack Web Apps for both the front-end and back-end project directories. Apart from using HTML and CSS, we also use JavaScript, ReactJs, and Firebase to create full-stack web apps."/>

        <ServicesCard icon="fa-solid fa-file-lines" title="Copy writing" text="We create engaging web pages, landing pages, and sales copies to increase brand awareness that persuades users to take the required action."/>

        <ServicesCard icon="fa-solid fa-newspaper" title="Blog & Artical writing" text="When writing blogs, we focus on creating appealing graphics, magnetic headlines & subheadings, powerful calls to action, relevant internal links, and concise Meta descriptions so that our content engages readers to take the required action."/>

        <ServicesCard icon="fa-solid fa-ferry" title="Logo Design" text="We create professional, distinctive, and simple in form business logo design so that it conveys your intended message to your potential customers."/>

        <ServicesCard icon="fa-solid fa-photo-film" title="Photo Editing" text="Our skilled graphic designer aims to take a quality shot, choose relevant filters, adjust the Lux setting and create professional and eye-catching photos."/>
      </section>
    </div>
  )
}

export default Services
